import { render, staticRenderFns } from "./page-pusher-account.vue?vue&type=template&id=08215bd5&scoped=true&"
import script from "./page-pusher-account.vue?vue&type=script&lang=js&"
export * from "./page-pusher-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08215bd5",
  null
  
)

export default component.exports